module.exports = __webpack_public_path__ + "img/4-3.93af19e7.png";